/**
 * Created by vladislav on 25.02.2020
 */

const PassMissionLogic = function (mission, isNewMission) {
    this.mission = mission;

    this.onShowWindowListeners = {};
    this.onUpdateListeners = {};
    this.onLevelChangedListeners = {};
    this.onProgressChangedListeners = {};
    this.onPremiumPurchaseFailedListeners = {};

    let goalTotal = 0;
    this.levels = this.mission.levels.map((level, index) => {
        goalTotal += level.task.goal;

        const newLevel = { level: index, ...level };

        newLevel.task.goalTotal = goalTotal;
        return newLevel;
    });

    this.load(this.mission.details);

    if (this.mission.isRunning()) {
        this.mission.logEvent(Mission.EVENTS.MISSION_STAGE, { itemId: `${this.progress.level}`, once: true });
    }

    if (this.checkComplete()) {
        this.mission.complete();
    }

    this.shownAvailableRewards = this._getAvailableRewardsSet();

    if (this.mission.mapPoints) {
        cleverapps.eventBus.on("mapEvent", this.onMapEvent.bind(this), this);
    }

    this.mission.onChangeResults = this.runListeners.bind(this, this.onUpdateListeners);

    this.onAnimateAmountChange = function () {};
    this.onNextAmountStep = function () {};
    this.onAnimateProgressChange = function () {};
    this.onNextProgressStep = function () {};
    this.onShowFinger = function () {};
    this.onHideFinger = function () {};

    this.onPremiumPurchaseFinished = function () {};

    if (isNewMission) {
        this.getProduct().saveVideoProgress(0);
    }
};

PassMissionLogic.prototype.destructor = function () {
    runCleaners(this);
};

PassMissionLogic.prototype.runListeners = function (listeners) {
    for (const key in listeners) {
        const listener = listeners[key];
        if (listener) {
            listener();
        }
    }
};

PassMissionLogic.prototype.showProgress = function () {
    if (this.isAllProgressShown()) {
        this.onShowFinger();
        return;
    }

    let nextProgress = this.shownProgress.level >= this.progress.level ? {
        level: this.progress.level,
        progress: this.progress.progress
    } : {
        level: this.shownProgress.level,
        progress: this.levels[this.shownProgress.level].task.goal
    };

    this.onAnimateAmountChange(nextProgress, this.shownProgress, this.levels[this.shownProgress.level].task.goal);
    this.onAnimateProgressChange(nextProgress, () => {
        if (this.shownProgress.level >= this.progress.level) {
            this.shownProgress = nextProgress;
            this.saveProgress();
            this.showProgress();
            return;
        }

        nextProgress = {
            level: this.shownProgress.level + 1,
            progress: 0
        };

        this.onNextAmountStep(nextProgress);
        this.onNextProgressStep(this.shownProgress.level, () => {
            this.shownProgress = nextProgress;
            this.saveProgress();
            this.runListeners(this.onLevelChangedListeners);
            this.showProgress();
        });
    });
};

PassMissionLogic.prototype.checkComplete = function () {
    return this.isAllTasksCompleted() && this.hasPremium() && this.countAvailableRewards() === 0;
};

PassMissionLogic.prototype.saveProgress = function () {
    this.mission.details = this.getInfo();
    this.mission.update(0, this.getInfo());
};

PassMissionLogic.prototype.load = function (data) {
    const arrayToBits = function (array) {
        return array.reduce((rewards, value) => rewards | (1 << value), 0);
    };

    this.premium = data.premium || data.boughtPremium || undefined;

    this.rewards = data.rewards || 0;
    this.premiumRewards = data.premiumRewards || 0;
    this.progress = data.progress || 0;

    // migrate
    if (Array.isArray(data.levelsToReward)) {
        this.rewards = arrayToBits(data.levelsToReward);
    }

    if (Array.isArray(data.levelsToPremReward)) {
        this.premiumRewards = arrayToBits(data.levelsToPremReward);
    }

    if (data.currentTask) {
        const level = Math.min(data.currentTask.level || 0, this.levels.length - 1);
        const progress = data.currentTask.progress || 0;
        this.progress = this.levels[level].task.goalTotal - this.levels[level].task.goal + progress;
    }

    this.shownProgress = data.shownProgress || this.progress;

    this.progress = this._extract(this.progress);
    this.shownProgress = this._extract(this.shownProgress);

    // guard
    const mask = (1 << this.progress.level) - 1;
    this.rewards &= mask;
    this.premiumRewards &= mask;
};

PassMissionLogic.prototype.getInfo = function () {
    return {
        premium: this.premium,
        rewards: this.rewards,
        premiumRewards: this.premiumRewards,
        progress: this._compact(this.progress),
        shownProgress: this._compact(this.shownProgress)
    };
};

PassMissionLogic.prototype.completeCurrentTask = function () {
    if (this.progress.level < this.levels.length) {
        this.addProgress(this.levels[this.progress.level].task.goal - this.progress.progress);
    }
};

PassMissionLogic.prototype.takeLevelReward = function (level, premium) {
    if (!this.hasReward(level, premium)) {
        return;
    }

    const reward = premium ? this.levels[level].premiumReward : this.levels[level].reward;

    if (reward.unit && ["merge", "merge2"].includes(cleverapps.config.type) && !this.mission.mainWorldReward) {
        const left = cleverapps.toArray(reward.unit).reduce((total, unit) => total + unit.amount, 0) - Map2d.currentMap.countEmptySlots();
        if (left > 0) {
            cleverapps.centerHint.createTextHint(Messages.get("Spawn.nospace", { left }));
            return;
        }
    }

    if (premium) {
        this.premiumRewards ^= (1 << level);
    } else {
        this.rewards ^= (1 << level);
    }

    this.shownAvailableRewards = this._getAvailableRewardsSet();

    this.saveProgress();

    this._logEventByType(`${premium ? cleverapps.EVENTS.PASS_RECEIVED_PREMIUM : cleverapps.EVENTS.PASS_RECEIVED}_${level}`);
    this.mission.logEvent(Mission.EVENTS.MISSION_REWARD_VALUE, { reward, itemId: `${level}` });

    if (this.checkComplete()) {
        this.mission.logEvent(Mission.EVENTS.MISSION_FINISH, { once: true });
        this.mission.complete();
    }

    return reward;
};

PassMissionLogic.prototype.receiveReward = function () {
    if (this.mission.manualFinish) {
        for (let i = 0; i < this.levels.length; ++i) {
            let reward = this.takeLevelReward(i, false);
            if (reward) {
                return reward;
            }

            if (this.hasPremium()) {
                reward = this.takeLevelReward(i, true);
                if (reward) {
                    return reward;
                }
            }
        }
    }
};

PassMissionLogic.prototype.hasReward = function (level, premium) {
    return (premium ? this.premiumRewards : this.rewards) & (1 << level);
};

PassMissionLogic.prototype.setPremium = function () {
    this.premium = 1;
    this.runListeners(this.onUpdateListeners);
    this.saveProgress();

    this._logEventByType(cleverapps.EVENTS.PASS_PURCHASED_TICKET);
};

PassMissionLogic.prototype.isCompletedTaskShown = function () {
    return this.progress.level === this.shownProgress.level;
};

PassMissionLogic.prototype.isAllTasksCompleted = function () {
    return this.progress.level >= this.levels.length;
};

PassMissionLogic.prototype.isAllProgressShown = function () {
    return this.progress.level === this.shownProgress.level && this.progress.progress === this.shownProgress.progress;
};

PassMissionLogic.prototype.countAvailableRewards = function () {
    const rewardsArray = this._getAvailableRewardsSet();
    let totalCount = 0;

    for (let i = 0; i < rewardsArray.length; i++) {
        const reward = rewardsArray[i];

        const binaryStr = reward.toString(2);

        const matches = binaryStr.match(/1/g);

        if (matches) {
            totalCount += matches.length;
        }
    }

    return totalCount;
};

PassMissionLogic.prototype.addProgress = function (amount) {
    if (!amount) {
        return;
    }

    this.mission.logEvent(Mission.EVENTS.MISSION_ACTION, { once: true });

    const progress = this._extract(this._compact(this.progress) + amount);

    for (let i = this.progress.level; i < progress.level; i++) {
        this.rewards |= (1 << i);
        this.premiumRewards |= (1 << i);
        this._logEventByType(`${cleverapps.EVENTS.PASS_FINISH_TASK}_${i}`);

        const leftTime = this.mission.getTimeLeft();
        if (leftTime <= cleverapps.parseInterval("3 days")) {
            let timeout;

            if (!this.isAllTasksCompleted()) {
                const targetTime = new Date();
                targetTime.setHours(21, 0, 0);

                const tillTargetTime = targetTime - Date.now();
                if (tillTargetTime > 0 && tillTargetTime < (leftTime - cleverapps.parseInterval("10 minutes"))) {
                    timeout = tillTargetTime;
                }
            }

            PushHelper.sendPush(PUSHES.PASS_UNCOMPLETED, timeout);
        }
    }

    const levelChanged = this.progress.level !== progress.level;

    this.progress = progress;
    this.saveProgress();

    if (levelChanged) {
        this.mission.logEvent(Mission.EVENTS.MISSION_STAGE, { itemId: `${progress.level}` });
    }

    this.runListeners(this.onProgressChangedListeners);
};

PassMissionLogic.prototype.hasPremium = function () {
    return this.premium;
};

PassMissionLogic.prototype.canBuyPremium = function () {
    return !this.hasPremium() && (this.mission.isRunning() || this.progress.level !== 0);
};

PassMissionLogic.prototype.canRemoveSilently = function () {
    return false;
};

PassMissionLogic.prototype.canRemove = function () {
    return this.countAvailableRewards() === 0;
};

PassMissionLogic.prototype.hasLastChance = function () {
    return !this.isAllTasksCompleted();
};

PassMissionLogic.prototype.processEvent = function (options) {
    this.addProgress(options.amount);
    this.displayWindow(1000);
};

PassMissionLogic.prototype.handleShowWindow = function () {
    this.shownAvailableRewards = this._getAvailableRewardsSet();
    this.runListeners(this.onShowWindowListeners);
};

PassMissionLogic.prototype.stop = function () {
    cleverapps.missionManager.trigger("erasePassPoints");
};

PassMissionLogic.prototype.beforeRemove = function (f) {
    if (typeof Map2dLocation !== "undefined" && cleverapps.environment.isMainScene() && cleverapps.meta.getSelectedLocation().locationConfig.isMain) {
        Map2dLocation.currentLocation.thirdElementPlanner.planNext({
            type: ThirdElement.TYPE_PASS_FINISH,
            delay: 200,
            target: this.levels[this.levels.length - 1].premiumReward.unit
        });
    }

    f();
};

PassMissionLogic.prototype.onMapEvent = function (type, options) {
    if (!cleverapps.meta.getSelectedLocation().locationConfig.isMain && MissionManager.hasProperLocation(this.mission.type)
        && this.mission.isRunning() && !this.isAllTasksCompleted()) {
        let unit;

        switch (type) {
            case Map2d.SPAWN: unit = !Array.isArray(options.affected) && options.unit; break;
            case Map2d.BUILD: unit = options.affected; break;
        }

        if (unit && unit.getData().bpPoints) {
            unit.setPoints(unit.getData().bpPoints);
        }

        unit = type === Map2d.SPAWN && Array.isArray(options.affected) && options.unit;
        if (unit && unit.getData().mergeBpPoints) {
            unit.setPoints(unit.getData().mergeBpPoints);
        }
    }
};

PassMissionLogic.prototype.getTargets = function () {
    return ["battlePass"];
};

PassMissionLogic.prototype.isAttentionRequired = function () {
    return this.countAvailableRewards() > 0;
};

PassMissionLogic.BuildableUnitPoints = function (unit) {
    const values = [0, 0, 5, 10, 20, 60, 300, 600, 2000, 2500, 3000, 4000];
    return values[Math.min(unit.stage, values.length - 1)];
};

PassMissionLogic.prototype.needDisplayWindow = function () {
    const newRewards = this._getAvailableRewardsSet();
    const shownRewards = this.shownAvailableRewards || [];

    function contains(array, item) {
        return array.indexOf(item) !== -1;
    }

    let hasNewRewards = false;
    for (let i = 0; i < newRewards.length; i++) {
        if (!contains(shownRewards, newRewards[i])) {
            hasNewRewards = true;
            break;
        }
    }

    return hasNewRewards;
};

PassMissionLogic.prototype.displayWindow = function (delay) {
    if (!this.needDisplayWindow()) {
        return;
    }

    delay = delay || 0;

    cleverapps.focusManager.display({
        focus: "PassWindow",
        actions: [
            function (f) {
                cleverapps.focusManager.showControlsWhileFocused(`${this.mission.name}MissionIcon`);

                setTimeout(f, delay);
            }.bind(this),
            function (f) {
                cleverapps.focusManager.hideControlsWhileFocused(`${this.mission.name}MissionIcon`);

                const MissionViewClass = this.mission.getViewClass();
                new MissionViewClass(this.mission);
                cleverapps.focusManager.onceNoWindowsListener = f;
            }.bind(this)
        ]
    });
};

PassMissionLogic.prototype._compact = function (progress) {
    let total = 0;
    for (let level = 0; level < progress.level; level++) {
        total += this.levels[level].task.goal;
    }

    return total + progress.progress;
};

PassMissionLogic.prototype.gamePlayed = function (game, level) {
    if (game.outcome !== GameBase.OUTCOME_VICTORY) {
        return;
    }

    const amount = {
        hard: 6,
        tricky: 4
    }[level.getRewardTag()] || 3;

    game.addMissionReward(this.mission.type, amount);
};

PassMissionLogic.prototype._extract = function (progress) {
    let total = 0;
    for (let level = 0; level < this.levels.length; level++) {
        if (progress < total + this.levels[level].task.goal) {
            return {
                level,
                progress: progress - total
            };
        }

        total += this.levels[level].task.goal;
    }

    return {
        level: this.levels.length,
        progress: 0
    };
};

PassMissionLogic.prototype._getAvailableRewardsSet = function () {
    if (this.hasPremium()) {
        return [
            this.rewards, this.premiumRewards
        ];
    }
    return [this.rewards];
};

PassMissionLogic.prototype._logEventByType = function (name, params) {
    const prefix = typeof this.mission.eventPrefix === "function" ? this.mission.eventPrefix() : this.mission.eventPrefix;
    if (prefix) {
        name = `${prefix}_${name}`;
    }

    cleverapps.metrics.logEvent(name, params);
};

PassMissionLogic.prototype.getTicketJson = function () {
    return bundles.passtickets.jsons[this.mission.ticketJson || "ticket_json"];
};

PassMissionLogic.prototype.getCollectIcon = function () {
    return Mission.getCollectIcon(this.mission.type);
};

PassMissionLogic.prototype.buyPremium = function () {
    this.getProduct().buy(this.processPremiumBought.bind(this), { noRewardWindow: true });
};

PassMissionLogic.prototype.processPremiumBought = function (success) {
    if (!success) {
        this.onPremiumPurchaseFinished(false);
        this.runListeners(this.onPremiumPurchaseFailedListeners);
        return;
    }

    this.setPremium();
    this.onPremiumPurchaseFinished(true);

    cleverapps.focusManager.display({
        focus: "RewardWindow",
        stack: true,
        action: (f) => {
            new RewardWindow({
                battlePass: { missionType: this.mission.type }
            });
            cleverapps.focusManager.onceNoWindowsListener = f;
        }
    });
};

PassMissionLogic.prototype.getPriceText = function () {
    return this.getProduct().getCurrentPrice();
};

PassMissionLogic.prototype.getProduct = function () {
    return Product.CreateByHardPrice(PassMissionLogic.GetHardPrice(), {
        type: "pass_ticket",
        mission: this.mission.type
    });
};

PassMissionLogic.GetHardPrice = function () {
    return 999;
};

PassMissionLogic.classifyAmount = function (amount) {
    if (amount > 300) {
        return 3;
    } if (amount > 80) {
        return 2;
    }
    return 1;
};

Restorable.BY_TYPE["pass_ticket"] = new Restorable({
    location: Restorable.LocationMission,
    find: Restorable.FindRunningMission,
    give: (mission) => mission.logic.processPremiumBought(true)
});
